<template>
	<div class="newDataClass">
		<div class="leftDivClass">
			<h4 style="padding: 20px; padding-bottom: 0">{{ $t('system.infoData.RecentNews') }}</h4>
			<span :class="activeIndex == index ? 'spanNameClass2' : 'spanNameClass'" v-for="(item, index) in dataObject" :key="index" :title="item.dictLabel" @click="changeTypeItem(item, index)">
				<!-- <img :src="activeIndex == index ? item.img1 : item.img2" /> -->
				{{ item.dictLabel }}
			</span>
		</div>
		<div class="rightDivClass">
			<div class="titleClass">
				<router-link to="/">{{ $t('system.headerMenu.HomePage') }} / </router-link>
				<!-- <span>{{ $t('system.infoData.OngoingNews') }} / </span> -->
				<span @click="currentItem = ''">{{ currentTypeValue }}</span>
				<span v-if="currentItem" style="color: #3a8ee6"> {{ '/' + currentItem }}</span>
			</div>

			<div class="titleContentClass" v-show="!currentItem">
				<div v-if="newDataArr && newDataArr.length > 0">
					<div class="titleNameClass" v-for="(item, index) in newDataArr" :key="index" @click="changeItemFunc(item.newsType, item.id, item.foreignId, item)">
						<span><i class="el-icon-caret-right"></i>{{ item.title }}</span>
						<span>{{ $t('system.infoData.ReleaseTime') }}：{{ item.createTime }}</span>
					</div>
					<div style="display: flex; justify-content: end">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="pageNum"
							:page-sizes="[10, 20, 30, 50]"
							:page-size="100"
							layout="total, sizes, prev, pager, next, jumper"
							:total="listTotal"
						>
						</el-pagination>
						<el-button size="mini" @click="goPage()">Go</el-button>
					</div>
				</div>
				<div v-else><el-empty description="暂无数据"></el-empty></div>
			</div>

			<div class="titleContentClass" v-show="currentItem">
				<div class="infoDivClass">
					<h1 class="title1Class">{{ currentObj.title }}</h1>
					<h2 class="title2Class">发布时间：{{ currentObj.createTime }}浏览次数：{{ currentObj.views }}</h2>
					<ul class="contentClass">
						<li v-html="currentObj.content"></li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	components: {},
	data() {
		return {
			currentPage: 1,
			listTotal: 0,
			pageSize: 10, //页
			pageNum: 1, //条
			newDataArr: [],
			newsType: '',
			tempObj: {},
			infoId: '',
			currentObj: {},
			dataPublish: [],
			dynamicNews: [],
			latestNewsData: [],
			noticData: [],
			otherData: [],

			currentTypeValue: '',
			currentItem: '',
			activeIndex: 0,

			dataObject: [
				// { img1: require('./../../assets/moonsamples/编号1.png'), img2: require('./../../assets/moonsamples/编号2.png'), name: this.$t('system.infoData.DataRelease') },
				// { img1: require('./../../assets/moonsamples/流程还1.png'), img2: require('./../../assets/moonsamples/流程还2.png'), name: this.$t('system.infoData.OngoingNews') },
				// { img1: require('./../../assets/moonsamples/编号1.png'), img2: require('./../../assets/moonsamples/编号2.png'), name: this.$t('system.infoData.LatestProduct') },
				// { img1: require('./../../assets/moonsamples/流程还1.png'), img2: require('./../../assets/moonsamples/流程还2.png'), name: this.$t('system.infoData.NoticeandAnnouncement') },
				// { img1: require('./../../assets/moonsamples/流程还1.png'), img2: require('./../../assets/moonsamples/流程还2.png'), name: this.$t('system.infoData.TasksIntroduction') }
			]
		}
	},
	beforeCreate() {},
	watch: {},
	mounted() {
		this.getDictTypeFunc()
		console.log(this.$route.query)
		this.currentItem = ''
		this.currentTypeValue = ''
		// 1:数据发布,2:动态新闻,3:最新成果,4:通知公告,5:其他;6：任务介绍
		if (this.$route.query.type == 1) {
			this.currentTypeValue = this.$t('system.infoData.DataRelease')
			this.activeIndex = 0
		} else if (this.$route.query.type == 2) {
			this.currentTypeValue = this.$t('system.infoData.OngoingNews')
			this.activeIndex = 1
		} else if (this.$route.query.type == 3) {
			this.currentTypeValue = this.$t('system.infoData.LatestProduct')
			this.activeIndex = 2
		} else if (this.$route.query.type == 4) {
			this.currentTypeValue = this.$t('system.infoData.NoticeandAnnouncement')
			this.activeIndex = 3
		} else if (this.$route.query.type == 5) {
			this.currentTypeValue = this.$t('system.infoData.Other')
			this.activeIndex = 4
		} else if (this.$route.query.type == 6) {
			this.currentTypeValue = this.$t('system.infoData.TasksIntroduction')
			this.activeIndex = 5
		}
		if (this.$route.query.id) {
			this.changeItemFunc(this.$route.query.type, this.$route.query.id, this.$route.query.foreignId)
		}
		this.newsType = this.$route.query.type
		this.initDataFunc()
	},
	methods: {
		handleSizeChange(val) {
			this.pageSize = val
			this.initDataFunc()
		},
		handleCurrentChange(val) {
			this.goPageNum = val
			this.pageNum = val
			this.initDataFunc()
		},
		goPage() {
			this.pageNum = this.goPageNum
			this.initDataFunc()
		},
		homePageFunc() {
			this.$router.replace({ path: '/' })
		},
		changeTypeItem(item, index) {
			// this.$router.replace({ path: '/HomeList', query: { type: item.dictValue } })
			// localStorage.removeItem('tempObj')
			this.activeIndex = index
			this.currentTypeValue = item.dictLabel
			this.currentItem = ''
			this.newsType = item.dictValue
			this.initDataFunc()
		},
		async changeItemFunc(type, id, foreignId, item) {
			// this.currentItem = item.title
			// this.currentObj = item
			// localStorage.removeItem('tempObj')
			this.$router.replace({ path: '/HomeInfo', query: { type: type, id: id, currentName: this.currentTypeValue } })
		},
		async getDictTypeFunc() {
			let res = await this.$http.get(this.$const.common.getDictType + '/news_type')
			this.dataObject = res.data
			console.log(this.dataObject)
		},
		async initDataFunc() {
			this.newDataArr = []
			let pageObj = {
				pageNum: this.pageNum,
				pageSize: this.pageSize,
				newsType: this.newsType
			}
			let res = await this.$http.get(this.$const.common.newsListURL, pageObj)
			if (res.code === 200) {
				this.listTotal = res.total
				// 新闻资讯类型;1:数据发布,2:动态新闻,3:最新成果,4:通知公告,5:其他
				this.newDataArr = res.rows
			}
		}
	}
}
</script>

<style lang="scss" scoped>
/* 容器内所有sub标签强制和父文字大小一致 */
.html-content :deep(sub) {
	font-size: inherit !important; /* 继承父级字号，不缩小 */
	vertical-align: baseline !important; /* 取消下沉下标偏移，对齐文字 */
}
.newDataClass {
	width: 70%;
	height: auto;
	margin: 0 auto;
	margin-top: 20px;
	min-height: 68vh;
	margin-bottom: 20px;
	display: flex;
	justify-content: space-between;
	.leftDivClass {
		width: 180px;
		background-color: #ffffff;
		.spanNameClass,
		.spanNameClass2 {
			cursor: pointer;
			// height: 40px;
			font-family: MicrosoftYaHeiUI;
			font-size: 18px;
			color: #333333;
			display: flex;
			font-style: normal;
			align-items: center;
			line-height: 40px;
			padding-top: 20px;
			padding-left: 20px;
			img {
				padding-right: 10px;
			}
		}
		.spanNameClass2 {
			color: #2a8eec;
		}
	}
	.rightDivClass {
		display: flex;
		width: 85%;
		flex-direction: column;
		background-color: #fff;
		height: auto;
		padding: 20px;
		.titleClass {
			height: 40px;
			line-height: 40px;
			color: #000;
			font-size: 16px;
			font-weight: 600;
			cursor: pointer;
		}
		.titleContentClass {
			display: flex;
			flex-direction: column;
			// width: 1350px;
			.titleNameClass {
				display: flex;
				padding: 20px;
				// width: 864px;
				height: 54px;
				font-family: MicrosoftYaHeiUI;
				font-size: 14px;
				color: #333333;
				letter-spacing: 0;
				font-weight: 400;
				justify-content: space-between;
				border-bottom: 1px solid #eeeeee;
				cursor: pointer;
			}
			.titleNameClass:hover {
				background: rgba(21, 65, 140, 0.08);
				font-family: MicrosoftYaHeiUISemibold;
				font-size: 14px;
				color: #15418c;
				letter-spacing: 0;
				font-weight: 600;
			}
			.infoDivClass {
				padding: 20px;
				.title1Class,
				.title2Class {
					text-align: center;
				}
				.title2Class {
					color: #999;
					font-size: 12px;
					margin-top: 10px;
					text-align: center;
					margin-bottom: 10px;
				}
				.contentClass {
					font-family: MicrosoftYaHeiUI;
					// font-size: 18px;
					color: #333333;
					line-height: 38px;
					text-align: left;
					font-style: normal;
					text-indent: 2em;
				}
			}
		}
	}

	.contentClass p img {
		width: 100% !important;
		margin-left: -2em;
	}
}
</style>
